import React from "react";

const TagDetail = ({ className, nameAtt, summary, details, icon }) => {

  return (
    <details
      className={className}
      name={nameAtt}
      open={false}
    >
      <summary>
        <span>
        {summary}
        </span>
        {icon ? <i /> : ''}
      </summary>
      {details}
    </details>
  )
}

export default TagDetail;